import { render, staticRenderFns } from "./Produktgruppenliste.vue?vue&type=template&id=a2c3a158&"
import script from "./Produktgruppenliste.vue?vue&type=script&lang=js&"
export * from "./Produktgruppenliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports